import { render, staticRenderFns } from "./ToolsPane.vue?vue&type=template&id=51cfe2ec&scoped=true"
import script from "./ToolsPane.vue?vue&type=script&lang=js"
export * from "./ToolsPane.vue?vue&type=script&lang=js"
import style0 from "./ToolsPane.vue?vue&type=style&index=0&id=51cfe2ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cfe2ec",
  null
  
)

export default component.exports